export default (value: number) => {
    switch (value) {
        case 1:
            return "Document Analysis";
        default:
            return "Unknown";
    }
}
